<template>
  <div>
    <div class="glz animation">
      <img :src="list[0].imageUrl" />
      <div class="whbfb txt3">
        <div class="table">
          <div class="table-cell" v-html="list[0].content"></div>
        </div>
      </div>
    </div>
    <div class="jjygd">
      <div
        class="li clearfix animation srcospcur"
        v-for="(item,index) in list.slice(1)"
        :key="item.id"
      >
        <div class="pic" :class="index%2==0?'fl':'fr'">
          <img width="100%" :src="item.imageUrl" />
        </div>
        <div class="con">
          <div class="con-new">
            <h3 class="ft24">{{item.listTitle}}</h3>
            <p v-html="item.content"></p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    data: [Object, Array]
  },
  data() {
    return {
      list: this.$props.data || []
    };
  }
};
</script>